module.exports = __webpack_public_path__ + "img/655450338.3fbcc8bf.jpg";